import { render } from "./ControlsSection.vue?vue&type=template&id=160dc892&ts=true"
import script from "./ControlsSection.vue?vue&type=script&lang=ts"
export * from "./ControlsSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__